export default __webpack_public_path__ + "static/media/header-1.e44487d0.jpg";